"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subMilliseconds = exports.datesHaveSameDayMonthYear = exports.isAfter = exports.getDays = exports.addDays = exports.format = exports.subDays = exports.calculateTimezoneOffset = exports.convertTZ = void 0;
var timeinit_1 = __importDefault(require("./timeinit"));
var timezones_1 = __importDefault(require("./timezones"));
var dayShortNames = [
    'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
];
var dayNames = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
];
var monthShortNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
var monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',
];
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    return ('0'.repeat(len) + String(val)).slice(-len);
};
function convertTZ(date, tzString) {
    try {
        return new Date(date.toLocaleString('en-US', { timeZone: tzString }));
    }
    catch (e) {
        var ct = Math.abs(date.getTimezoneOffset());
        var dt = date.getTime();
        var jant = Math.abs((new Date(date.getFullYear(), 0, 1)).getTimezoneOffset());
        var jult = Math.abs((new Date(date.getFullYear(), 6, 1)).getTimezoneOffset());
        var npc = Math.max(jant, jult);
        var timezone = timezones_1.default[tzString.toLowerCase()];
        var offset = timezone.u - ct;
        if (ct < npc) {
            offset = timezone.d - ct;
        }
        return new Date(dt + 60000 * offset);
    }
}
exports.convertTZ = convertTZ;
function calculateTimezoneOffset(date, date2) {
    var localTimezoneOffset = date.getTimezoneOffset();
    var time = Math.round(date.getTime() / 1000 / 60);
    var time2 = Math.round(date2.getTime() / 1000 / 60);
    var result = time2 - time - localTimezoneOffset;
    return Math.round(result / 60);
}
exports.calculateTimezoneOffset = calculateTimezoneOffset;
function subDays(date, days) {
    var dateOffset = (24 * 60 * 60 * 1000) * days;
    var myDate = new Date();
    myDate.setTime(date.getTime() - dateOffset);
    return myDate;
}
exports.subDays = subDays;
function format(date, mask) {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[Ll]|"[^"]*"|'[^']*'/g;
    var d = date.getDate();
    var D = date.getDay();
    var m = date.getMonth();
    var y = date.getFullYear();
    var H = date.getHours();
    var M = date.getMinutes();
    var s = date.getSeconds();
    var L = date.getMilliseconds();
    var flags = {
        d: d,
        dd: pad(d),
        ddd: dayShortNames[D],
        dddd: dayNames[D],
        m: m + 1,
        mm: pad(m + 1),
        mmm: monthShortNames[m],
        mmmm: monthNames[m],
        yy: String(y).slice(2),
        yyyy: y,
        h: H % 12 || 12,
        hh: pad(H % 12 || 12),
        H: H,
        HH: pad(H),
        M: M,
        MM: pad(M),
        s: s,
        ss: pad(s),
        l: pad(L, 3),
        L: pad(L > 99 ? Math.round(L / 10) : L),
        t: H < 12 ? 'a' : 'p',
        tt: H < 12 ? 'am' : 'pm',
        T: H < 12 ? 'A' : 'P',
        TT: H < 12 ? 'AM' : 'PM',
    };
    return mask.replace(token, function (s) { return s in flags ? flags[s] : s.slice(1, s.length - 1); });
}
exports.format = format;
function addDays(date, days) {
    return new Date(date.getTime() + days * 86400000);
}
exports.addDays = addDays;
function getDays(floorDate, ceilingDate, including) {
    var includeCeiling = including !== null && including !== void 0 ? including : true;
    if ((!includeCeiling && ceilingDate <= floorDate) || (includeCeiling && ceilingDate < floorDate)) {
        return [];
    }
    var days = [floorDate];
    var dayDate = new Date(floorDate);
    while (dayDate < ceilingDate) {
        dayDate = addDays(dayDate, 1);
        if (includeCeiling && dayDate <= ceilingDate) {
            days.push(dayDate);
        }
        else if (!includeCeiling && dayDate < ceilingDate) {
            days.push(dayDate);
        }
    }
    return days;
}
exports.getDays = getDays;
/** Returns true if date1 > date2
 *
 * date2 will default to the value of dateNow() if no input
 */
function isAfter(date1, date2) {
    return timeinit_1.default.utc(date1).isAfter(timeinit_1.default.utc(date2));
}
exports.isAfter = isAfter;
/** checks if two dates have same day, month and year */
function datesHaveSameDayMonthYear(date1, date2) {
    return timeinit_1.default.utc(date1).isSame(timeinit_1.default.utc(date2), 'day');
}
exports.datesHaveSameDayMonthYear = datesHaveSameDayMonthYear;
function subMilliseconds(date, milliseconds) {
    return new Date(date.getTime() - milliseconds);
}
exports.subMilliseconds = subMilliseconds;
